export enum EVersionType {
  WRITE_API_DESIGN = 'IN_WRITE_API_DESIGN',
  WRITE_API_DOCUMENT = 'IN_WRITE_API_DOCUMENT',
  IN_REVIEW_DESIGN = 'IN_REVIEW_DESIGN',
  IN_REVIEW_DOCUMENT = 'IN_REVIEW_DOCUMENT',
  APPROVED_DESIGN = 'APPROVED_DESIGN',
  APPROVED_DOCUMENT = 'APPROVED_DOCUMENT',
}
